"use strict";

// @IE9
var add;
var remove;
var contains; // eslint-disable-line import/no-mutable-exports

/* istanbul ignore else */

if (window.document.createElement('div').classList) {
  add = function (node, name) {
    return node.classList.add(name);
  };

  remove = function (node, name) {
    return node.classList.remove(name);
  };

  contains = function (node, name) {
    return node.classList.contains(name);
  };
} else {
  add = function (node, name) {
    var re = new RegExp("(^|\\s)" + name + "(\\s|$)", 'g');

    if (!re.test(node.className)) {
      node.className = (node.className + " " + name).replace(/\s+/g, ' ').replace(/(^ | $)/g, '');
    }
  };

  remove = function (node, name) {
    var re = new RegExp("(^|\\s)" + name + "(\\s|$)", 'g');
    node.className = node.className.replace(re, '$1').replace(/\s+/g, ' ').replace(/(^ | $)/g, '');
  };

  contains = function (node, name) {
    return new RegExp("(\\s|^)" + name + "(\\s|$)").test(node.className);
  };
}

var toggle = function (node, name, switcher) {
  if (switcher) {
    add(node, name);
  } else {
    remove(node, name);
  }
};

exports.toggle = toggle;
exports.contains = contains;